import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border: 1px solid #d4d9de;
  border-radius: 8px;
  background-color: var(--bg);
  color: var(--ink);
  font-family: var(--font-sans);
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease;

  &::placeholder {
    color: #80868b;
  }

  &:hover {
    border-color: #bdc1c6;
  }

  &:focus {
    border-color: var(--brand);
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(18, 100, 199, 0.15);
  }
`;
